module.exports = __webpack_public_path__ + "img/24_22.19443e62.png";